<script setup>

import {computed, onMounted, ref} from "vue";

const props = defineProps({
  member: {
    type: Object,
    required: true
  },
  width: {
    type: String,
    default:'31'
  },
  height: {
    type: String,
    default:'41'
  },
  font_size: {
    type: String,
    default: 'responsive-body-small'
  }
})
onMounted(() => {
  showInitials.value = false;
})

const showInitials = ref(false);

const initials = computed(() => {
  const first = props.member?.firstName ?? '';
  const last = props.member?.lastName ?? '';
  return `${first[0] || ''}${last[0] || ''}`.toUpperCase();
});

const displayName = computed(() => {
  if (props.member?.firstName && props.member?.lastName) {
    return `${props.member.firstName} ${props.member.lastName}`;
  }
  return props.member?.name || "";
});

</script>

<template>

  <div class="relative w-full">
    <!-- Price (right fixed) -->
    <div class="absolute right-0 top-1/2 -translate-y-1/2 text-no-wrap">
      <slot name="right" />
    </div>

    <!-- avatar + name + date (left)-->
    <div class="flex flex-row items-center gap-3">
      <div class="flex-shrink-0">
        <img
            v-if="member?.picture || member?.profileImage"
            :width="width"
            class="rounded-24xl avatar object-cover"
            :src="member?.picture || member?.profileImage"
            @error="e => { e.target.style.display = 'none'; showInitials = true; }"
        />
        <div
            v-if="showInitials"
            class="flex items-center justify-center responsive-body-medium rounded-24xl bg-bw-silver text-black font-bold pt-1"
            :style="{
              width: `${width}px`,
              height: `${width}px`,
            }"
        >
          {{ initials }}
        </div>
      </div>

      <div class="flex flex-col min-w-0">
        <div :class="['font-semibold truncate', `${font_size}`]">
          {{ displayName }}
        </div>
        <slot/>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>
